import apiService from '@services/apiService';
import Swal from 'sweetalert2/src/sweetalert2';

const GET_AUDIT = 'GET_AUDIT';
const GET_AUDIT_FAIL = 'GET_AUDIT_FAIL';
const GET_AUDIT_SUCCESS = 'GET_AUDIT_SUCCESS';
const HOME_BUTTON_CLICKED = 'HOME_BUTTON_CLICKED';
const OFFICE_PAGE_CLICKED = 'OFFICE_PAGE_CLICKED';
const SEARCH_AGENTS_PAGE_CLICKED = 'SEARCH_AGENTS_PAGE_CLICKED';
const SEARCH_LISTINGS_PAGE_CLICKED = 'SEARCH_LISTINGS_PAGE_CLICKED';

const initialState = {
  EntityID: '',
  tableName: null,
  class: null,
  UniqueID: '',
  data: [],
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_AUDIT:
      return {
        ...state,
        loading: true,
      };
    case GET_AUDIT_SUCCESS:
      return {
        ...state,
        EntityID: action.payload.EntityID,
        tableName: action.payload.data.tableName,
        class: action.payload.data.class,
        UniqueID: action.payload.data.UniqueID,
        data: action.payload.data.data,
        loading: false,
      };
    case GET_AUDIT_FAIL:
      return {
        ...state,
        loading: false,
      };
    case HOME_BUTTON_CLICKED:
    case OFFICE_PAGE_CLICKED:
    case SEARCH_AGENTS_PAGE_CLICKED:
    case SEARCH_LISTINGS_PAGE_CLICKED:
      return initialState;
    default:
      return state;
  }
};

export const getAuditLog = ({ tableName, uniqueID, entityID }) => async dispatch => {
  const payload = {};
  payload.EntityID = entityID;
  dispatch({ type: GET_AUDIT });
  try {
    payload.data = await apiService.AuditLog.GetAuditLog({ tableName, uniqueID, entityID });
    dispatch({
      type: GET_AUDIT_SUCCESS,
      payload,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Error: Audit getAuditLog', err);
    dispatch({ type: GET_AUDIT_FAIL });
  }
  Swal.close();
  return dispatch;
};
